<ng-template #iconOrImageTemplate>
	@if (noDataImage(); as noDataImage) {
	<div libFlexColumn>
		<lib-image
			[priority]="true"
			[isRound]="false"
			[alt]="'No data'"
			[maxHeight]="100"
			[maxWidth]="100"
			[imageSize]="'250px'"
			[image]="noDataImage"
		></lib-image>
	</div>
	} @else { @if (calculatedIcon(); as icon) {
	<div libFlexColumn>
		<lib-icon [color]="iconColor()" [size]="'default'" [type]="icon"></lib-icon>
	</div>
	} }
</ng-template>

@if (!isDismissed()) {
<div [ngClass]="className()">
	<div class="ui-message" [class.mobile]="isMobileView()" [ngClass]="type()">
		<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'12px'">
			@if (messageDesign() === 'standalone' && calculatedIcon(); as icon) {
			<ng-template [ngTemplateOutlet]="iconOrImageTemplate"></ng-template>
			}
			<div libFlexColumn libFlexFill>
				@if (icon() || title() || button() ) {
				<div libFlexRow [libFlexRowGap]="'12px'" class="push-bottom-sm">
					@if (messageDesign() === 'combined') {
					<ng-template [ngTemplateOutlet]="iconOrImageTemplate"></ng-template>
					} @if (title(); as title) {
					<div libFlexColumn class="title">
						{{ title }}
					</div>
					}
				</div>
				}

				<div libWordBreak>
					<ng-content></ng-content>
				</div>
			</div>
			@if (button(); as button) {
			<div libFlexColumn>
				<lib-button-list [buttons]="[button]"></lib-button-list>
			</div>
			} @if (isDismissable()) {
			<div libFlexColumn>
				<lib-button
					[libTooltip]="'Dismiss message'"
					[icon]="'close'"
					[iconOnly]="true"
					(click)="dismissMessage()"
				></lib-button>
			</div>

			}
		</div>
	</div>
</div>
}
